import React from 'react';
import { MailIcon } from 'lucide-react';
import { SUPPORT_EMAIL } from '../utils/constants';
export function Footer() {
  return <footer className="w-full bg-night px-4 py-6" data-id="element-100" data-mp="3gg0zo4mhnzy6">
      <div className="mx-auto max-w-2xl text-center" data-id="element-101" data-mp="32nuhkczrziw3">
        <p className="font-head text-base font-bold uppercase leading-none text-white sm:text-xl" data-id="element-102" data-mp="32pfh6h0y5s0t">
          Spanish Teacher Pro™
        </p>
        <p className="mt-1 text-[11px] leading-snug text-silver" data-id="element-103" data-mp="3uf0lz5mj42r6">
          The complete professional system for Spanish teachers who want structured, adaptable and
          ready-to-use teaching resources. Because an experienced Spanish teacher shouldn’t have to
          rebuild every lesson from scratch every week.
        </p>

        <p className="mt-1.5 flex flex-wrap items-center justify-center gap-1 text-[11px] text-silver" data-id="element-104" data-mp="3qcdsz1e4gbse">
          <MailIcon className="h-3.5 w-3.5 text-cta" aria-hidden="true" data-id="element-105" data-mp="29y5l8cy0g70t" />
          Support:{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="underline transition-colors duration-150 ease-out hover:text-cta" data-id="element-106" data-mp="2ezbf4e3eq0bx">
            {SUPPORT_EMAIL}
          </a>
        </p>

        <p className="mt-1.5 text-[9px] text-silver/60" data-id="element-107" data-mp="3gaz213feglk3">
          © 2026 SPANISH TEACHER PRO™ — All Rights Reserved.
        </p>
        <p className="mx-auto mt-0.5 max-w-xl text-[9px] leading-snug text-silver/50" data-id="element-108" data-mp="3v8htidjgpcv8">
          The resources included in SPANISH TEACHER PRO™ are designed to support professional lesson
          preparation, teaching organization and student practice. Teachers remain responsible for
          selecting and adapting resources according to their students’ individual levels, goals and
          learning needs.
        </p>
        <p className="mt-0.5 text-[9px] text-silver/60" data-id="element-109" data-mp="huwgsshgdt46">
          Terms &amp; Conditions · Privacy Policy · Contact
        </p>
      </div>
    </footer>;
}